import emailjs from "@emailjs/browser";
import { render } from "@react-email/render";
import env from "react-dotenv";
import { toast } from "react-toastify";
import {
  //EmailToAdminTemplate,
  EmailToCustomerTemplate,
} from "../components/EmailTemplates";
import axios from "axios";

const {
  MAILJS_SERVICE_ID,
  //MAILJS_CUSTOMER_TEMPLATE_ID,
  MAILJS_ADMIN_TEMPLATE_ID,
  MAILJS_USER_ID,
} = env;

export const cutName = (name, cut) => {
  const arrName = name.split("");
  const idx = name.indexOf(cut);
  if (idx >= 0) arrName.splice(idx, cut.length);
  return arrName.join("");
};

export const validateLang = (lang) => {
  const allowedLangs = ["en", "ua"];
  return allowedLangs.includes(lang) ? lang : "en";
};

export const sendMail = async (data) => {
  const today = new Date();
  const prefix =
    ("0" + today.getDate()).slice(-2) +
    ("0" + (today.getMonth() + 1)).slice(-2);
  const orderNr = prefix + "-" + Math.random().toString(16).slice(7);

  const {
    name,
    email,
    //phone, address, message,
    order,
    //consent
  } = data;
  console.log("log before rendering HTML to customer");
  let htmlToCustomer;
  try {
    htmlToCustomer = await render(
      <EmailToCustomerTemplate name={name} order={order} orderNr={orderNr} />,
      { pretty: true, plainText: false, dangerouslyDisableReactDomStream: true }
    );
  } catch (error) {
    console.error(error);
  }

  console.log("log awter rendering HTML to customer");
  // console.log("log before rendering HTML to admin");

  // const htmlToAdmin = await render(
  //   <EmailToAdminTemplate
  //     name={name}
  //     order={order}
  //     phone={phone}
  //     email={email}
  //     address={address}
  //     message={message}
  //     orderNr={orderNr}
  //     consent={consent}
  //   />,
  //   { pretty: true }
  // );
  // console.log(
  //   "log after rendering HTML for admin. Length: ",
  //   htmlToAdmin.length
  // );

  try {
    console.log("log before sending email");

    await sendEmailToCustomer(name, email, htmlToCustomer);
    // await sendEmailToAdmin(name, orderNr, htmlToAdmin);
    console.log("log after sending email");

    toast.success("Your order has been sent successfully!");
  } catch (error) {
    toast.error("Error sending email: " + error.status);
    console.log("Error sending email: ", error);
  }
};

async function sendEmailToCustomer(name, email, htmlContent) {
  // const result = await emailjs.send(
  //   MAILJS_SERVICE_ID,
  //   MAILJS_CUSTOMER_TEMPLATE_ID,
  //   {
  //     name,
  //     email,
  //     htmlContent,
  //   },
  //   { publicKey: MAILJS_USER_ID }
  // );
  console.log(
    "ready to send! name, email, html length: ",
    name,
    email,
    htmlContent.length
  );

  const result = await axios.post("https://multicook-be.vercel.app/send", {
    name,
    email,
    htmlContent,
  });
  console.log("mail sent! mail id: ", result.data);

  return result.data;
}

async function sendEmailToAdmin(name, orderNr, htmlContent) {
  const result = await emailjs.send(
    MAILJS_SERVICE_ID,
    MAILJS_ADMIN_TEMPLATE_ID,
    {
      name,
      orderNr,
      htmlContent,
    },
    { publicKey: MAILJS_USER_ID }
  );
  return result;
}

typeof sendEmailToAdmin === "function" && console.log("/");

export const reorganizeData = (products, categories) => {
  // Step 1: Build category structure with categoryId, categoryName, and empty products array
  const formattedCategories = categories.map((category) => ({
    categoryId: category._id,
    categoryName: category.name,
    products: [],
  }));

  // Step 2: Create a map for fast lookup by categoryId
  const categoryMap = {};
  formattedCategories.forEach((category) => {
    categoryMap[category.categoryId] = category;
  });

  // Step 3: Process products
  products.forEach((product) => {
    const { _id, variants, categoryId, ...rest } = product;

    // Convert variants object to array
    const variantArray = Object.values(variants);

    // Build formatted product
    const formattedProduct = {
      productId: _id,
      categoryId,
      ...rest,
      variants: variantArray,
    };

    // Push product into corresponding category
    if (categoryMap[categoryId]) {
      categoryMap[categoryId].products.push(formattedProduct);
    }
  });

  // Step 4: Return the new structure
  return Object.values(categoryMap).filter(
    (category) => category.products.length > 0
  );
};

export const newSendMail = async (data) => {
  const today = new Date();
  const prefix =
    ("0" + today.getDate()).slice(-2) +
    ("0" + (today.getMonth() + 1)).slice(-2);
  const orderNr = prefix + "-" + Math.random().toString(16).slice(7);

  const { subtotal, taxGST, taxPST, delivery, total } = data;

  const dataToSend = {
    name: data.name,
    address: data.address,
    email: data.email,
    phone: data.phone,
    orderNr,
    products: data.order.map((item) => ({
      id: item.productId,
      name: item.productName.en + " - " + item.option,
      qty: item.qty,
    })),
    consent: data.consent,
    subtotal: "$" + subtotal.toString(),
    taxGST: "$" + taxGST.toString(),
    taxPST: "$" + taxPST.toString(),
    delivery: "$" + delivery.toString(),
    total: "$" + total.toString(),

    storeId: data.storeId,
    storeEmail: data.storeEmail || "order.multicookbrandon@gmail.com", // "0672182637@ukr.net",
    message: data.message || "",
  };
  try {
    const response = await axios.post(
      "https://multicook-be.vercel.app/mail/order",
      // "http://localhost:8080/mail/order",
      dataToSend
    );
    console.log("Email sent successfully:", response.data);
    toast.success("Your order has been sent successfully!");
  } catch (error) {
    console.error("Error sending email:", error);
    toast.error("Error sending email: " + error.message);
  }
};

export const calculateOrderSummary = (
  cartList,
  storeId,
  defaultStoreId = "682b89f4c28a3e5c9c0ce408"
) => {
  const subtotal = cartList
    .reduce((acc, curr) => acc + curr.price * curr.qty, 0)
    .toFixed(2);

  const taxGST = cartList
    .reduce((acc, curr) => {
      if (curr.taxGST) {
        return acc + curr.price * curr.qty * 0.05;
      } else {
        return acc;
      }
    }, 0)
    .toFixed(2);

  const taxPST = cartList
    .reduce((acc, curr) => {
      if (curr.taxGST) {
        return acc + curr.price * curr.qty * 0.07;
      } else {
        return acc;
      }
    }, 0)
    .toFixed(2);

  const deliveryFreeRate = storeId === defaultStoreId ? 50 : 200;

  const deliveryFee = storeId === defaultStoreId ? 4.99 : 7.99;

  const delivery =
    Number(subtotal) + Number(taxGST) + Number(taxPST) >= deliveryFreeRate
      ? 0
      : deliveryFee;

  const total = (
    Number(subtotal) +
    Number(taxGST) +
    Number(taxPST) +
    Number(delivery)
  ).toFixed(2);

  return { subtotal, taxGST, taxPST, delivery, total };
};
